import { useState, useEffect, useCallback } from 'react';
import { STATUS_TYPES } from '../utils/dataGenerator';

/**
 * Custom Hook für die automatische Status-Animation
 * Wechselt alle 10 Sekunden zwischen Grün -> Orange -> Rot (30s Gesamt-Zyklus)
 */
const useStatusAnimation = (autoPlay = true) => {
  const [currentStatus, setCurrentStatus] = useState(STATUS_TYPES.NORMAL);
  const [isPlaying, setIsPlaying] = useState(autoPlay);
  const [cycleCount, setCycleCount] = useState(0);

  const statusSequence = [
    STATUS_TYPES.NORMAL,    // 0-3.3s
    STATUS_TYPES.WARNING,   // 3.3-6.6s
    STATUS_TYPES.CRITICAL   // 6.6-10s
  ];

  const nextStatus = useCallback(() => {
    setCurrentStatus(prevStatus => {
      const currentIndex = statusSequence.indexOf(prevStatus);
      const nextIndex = (currentIndex + 1) % statusSequence.length;
      
      // Zyklus-Counter erhöhen wenn wir wieder bei NORMAL sind
      if (nextIndex === 0) {
        setCycleCount(prev => prev + 1);
      }
      
      return statusSequence[nextIndex];
    });
  }, []);

  const previousStatus = useCallback(() => {
    setCurrentStatus(prevStatus => {
      const currentIndex = statusSequence.indexOf(prevStatus);
      const prevIndex = currentIndex === 0 ? statusSequence.length - 1 : currentIndex - 1;
      return statusSequence[prevIndex];
    });
  }, []);

  const setStatus = useCallback((status) => {
    if (statusSequence.includes(status)) {
      setCurrentStatus(status);
    }
  }, []);

  const togglePlayPause = useCallback(() => {
    setIsPlaying(prev => !prev);
  }, []);

  const reset = useCallback(() => {
    setCurrentStatus(STATUS_TYPES.NORMAL);
    setCycleCount(0);
  }, []);

  // Automatische Status-Rotation
  useEffect(() => {
    if (!isPlaying) return;

    const interval = setInterval(() => {
      nextStatus();
    }, 10000); // 10 Sekunden (30s / 3 Stadien)

    return () => clearInterval(interval);
  }, [isPlaying, nextStatus]);

  return {
    currentStatus,
    isPlaying,
    cycleCount,
    togglePlayPause,
    nextStatus,
    previousStatus,
    setStatus,
    reset,
    statusSequence
  };
};

export default useStatusAnimation;
